import { Site, getEnWeekDay, memoize } from '@jucy-ui/common';

export const getDefaultTimes = memoize(({ date, branch }: { date: Date; branch?: Site }) => {
    const day = getEnWeekDay(date)?.toLowerCase();
    return (day && branch?.defaultTimes[day as keyof Site['defaultTimes']]) || { pickUp: '10:00', dropOff: '10:00' };
});
